import { cn } from '@/lib/utils';
import { ONBOARDING_STEP_COUNT } from '../types';

interface ProgressIndicatorsProps {
  currentStep: number;
  className?: string;
  variant?: 'light' | 'dark';
}

export function ProgressIndicators({
  currentStep,
  className,
  variant = 'light',
}: ProgressIndicatorsProps) {
  const isDark = variant === 'dark';

  return (
    <div
      data-slot="onboarding-progress"
      className={cn(
        'flex items-center gap-2 rounded-[20px] px-4 py-3 backdrop-blur-[15px]',
        isDark
          ? 'bg-white/10 shadow-[0_0_64px_rgba(26,22,19,0.1)]'
          : 'bg-white shadow-[0_0_16px_rgba(26,22,19,0.05)]',
        className,
      )}
    >
      {Array.from({ length: ONBOARDING_STEP_COUNT }, (_, index) => (
        <span
          key={index}
          className={cn(
            'h-1 w-6 rounded-[2px]',
            index <= currentStep
              ? 'bg-mf-green'
              : isDark
                ? 'bg-white/20'
                : 'bg-mf-neutral-200',
          )}
        />
      ))}
    </div>
  );
}
